(() => {
  const activateGallery = (gallery) => {
    if (!gallery || gallery.dataset.enhanced === 'true') return;
    gallery.dataset.enhanced = 'true';

    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const previousButton = gallery.querySelector('[data-gallery-prev]');
    const nextButton = gallery.querySelector('[data-gallery-next]');
    const counter = gallery.querySelector('[data-gallery-count]');

    const activateSlide = (position) => {
      if (!slides.length) return;
      const normalizedPosition = (position + slides.length) % slides.length;
      const target = slides[normalizedPosition].dataset.gallerySlide;

      slides.forEach((slide, index) => {
        const active = index === normalizedPosition;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        if (!active) slide.querySelector('video')?.pause();
      });

      thumbs.forEach((thumb) => {
        const active = thumb.dataset.galleryThumb === target;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (counter) counter.textContent = `${normalizedPosition + 1} / ${slides.length}`;
    };

    if (slides.length > 1) {
      [previousButton, nextButton, counter].forEach((control) => {
        if (control) control.hidden = false;
      });
      previousButton?.addEventListener('click', () => {
        const current = slides.findIndex((slide) => !slide.hidden);
        activateSlide(current - 1);
      });
      nextButton?.addEventListener('click', () => {
        const current = slides.findIndex((slide) => !slide.hidden);
        activateSlide(current + 1);
      });
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const position = slides.findIndex((slide) => slide.dataset.gallerySlide === thumb.dataset.galleryThumb);
        if (position >= 0) activateSlide(position);
      });
    });

    activateSlide(0);
  };

  const revealItems = (root) => {
    const items = root.querySelectorAll('.evebra-reveal:not([data-reveal-ready])');
    if (!items.length) return;
    items.forEach((item) => { item.dataset.revealReady = 'true'; });

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries, revealObserver) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    items.forEach((item) => observer.observe(item));
    window.setTimeout(() => items.forEach((item) => item.classList.add('is-visible')), 1600);
  };

  const activateSticky = (root) => {
    const sticky = root.querySelector('[data-evebra-sticky]');
    const heroBuy = root.querySelector('.evebra-buy');
    if (!sticky || !heroBuy || sticky.dataset.enhanced === 'true' || !('IntersectionObserver' in window)) return;
    sticky.dataset.enhanced = 'true';

    let heroVisible = true;
    let finalVisible = false;
    const updateSticky = () => sticky.classList.toggle('is-visible', !heroVisible && !finalVisible);

    new IntersectionObserver((entries) => {
      heroVisible = entries[0].isIntersecting;
      updateSticky();
    }, { threshold: 0.05 }).observe(heroBuy);

    const finalSection = document.querySelector('.evebra-pdp-2026 .evebra-final');
    if (finalSection) {
      new IntersectionObserver((entries) => {
        finalVisible = entries[0].isIntersecting;
        updateSticky();
      }, { threshold: 0.05 }).observe(finalSection);
    }
  };

  const enhance = (scope = document) => {
    scope.querySelectorAll('.evebra-pdp-2026').forEach((root) => {
      root.querySelectorAll('[data-evebra-gallery]').forEach(activateGallery);
      revealItems(root);
      activateSticky(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance());
  } else {
    enhance();
  }

  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
